import { useMemo } from "react";

function rand(seed) {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

export default function Particles({ count = 22 }) {
  const items = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = 3 + Math.round(rand(i + 1) * 6);
        const left = Math.round(rand(i + 7) * 100);
        const top = Math.round(rand(i + 13) * 100);
        const delay = (rand(i + 19) * 6).toFixed(2);
        const duration = (7 + rand(i + 23) * 8).toFixed(2);
        const opacity = (0.25 + rand(i + 31) * 0.5).toFixed(2);
        return { size, left, top, delay, duration, opacity };
      }),
    [count]
  );

  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      data-testid="gold-particles"
    >
      {items.map((p, idx) => (
        <span
          key={idx}
          className="particle"
          style={{
            width: `${p.size}px`,
            height: `${p.size}px`,
            left: `${p.left}%`,
            top: `${p.top}%`,
            opacity: p.opacity,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
          }}
        />
      ))}
    </div>
  );
}
